import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Card,
  Container,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";

// Component imports
import Hero from "../Components/Landing/Hero";
import Advert from "../Components/Landing/Advert";
import LandingFAQ from "../Components/Landing/faq";
import Pitch from "../Components/Landing/Pitch";
import Portfolio from "../Components/Landing/portfolio";
import Services from "../Components/Landing/Services";
import Pricing from "../Components/Landing/Pricing";
import Testimonials from "../Components/Landing/Testimonials";
import Footer from "../Components/Utils/Footer";
import Header from "../Components/Utils/Header";
import Maintenance from "../Components/Landing/Maintenance";

// Assets
import video from "../assets/videos/advert.mp4";

export default function Landing() {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Refs for scroll functionality
  const refs = {
    gis: useRef(null),
    web: useRef(null),
    marketing: useRef(null),
    newsletter: useRef(null),
    testimonials: useRef(null),
  };

  useEffect(() => {
    // Handle smooth scrolling based on URL hash
    const hash = location.hash.replace("#", "");
    if (hash && refs[hash]?.current) {
      refs[hash].current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  return (
    <Stack
      component="main"
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      <Header active="Home" landing={true} />

      <Hero index={5} />

      <Box sx={{ bgcolor: "background.paper" }}>
        <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
          <Card
            elevation={0}
            sx={{
              borderRadius: 2,
              overflow: "hidden",
              boxShadow: theme.shadows[4],
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "translateY(-4px)",
              },
            }}
          >
            <Box
              component="video"
              src={video}
              autoPlay
              loop
              muted
              sx={{
                width: "100%",
                height: "auto",
                display: "block",
                objectFit: "cover",
              }}
            />
          </Card>
        </Container>
      </Box>

      <Stack spacing={{ xs: 6, md: 8 }}>
        <Services ref={refs.gis} />
        {/* <Portfolio ref={refs.web} /> */}
        <Pitch ref={refs.marketing} />
        <Pricing />
        <Advert ref={refs.newsletter} />
        <Maintenance />
        <Testimonials ref={refs.testimonials} />
        <LandingFAQ />
      </Stack>

      <Footer />
    </Stack>
  );
}
